import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
// Import Containers
import { DefaultLayoutComponent } from "./containers";
import { LoginComponent } from "./views/login/login.component";
import { SialinkComponent } from "./views/sialink/sialink.component";
export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "MENU_USERS_LOGIN",
    },
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    children: [
      {
        path: "analytics",
        loadChildren: "./views/analytics/analytics.module#AnalyticsModule",
      },
    ],
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    children: [
      {
        path: "medias",
        loadChildren: "./views/medias/medias.module#MediasModule",
      },
    ],
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    children: [
      {
        path: "control",
        loadChildren:
          "./views/controlroom/controlroom.module#ControlRoomModule",
      },
    ],
  },
  {
    path: "admin",
    component: DefaultLayoutComponent,
    children: [
      {
        path: "areas",
        loadChildren: "./views/areas/areas.module#AreasModule",
      },
      {
        path: "devices",
        loadChildren: "./views/devices/devices.module#DevicesModule",
      },
      {
        path: "reports",
        loadChildren: "./views/reports/reports.module#ReportsModule",
      },
      {
        path: "sialink",
        component: SialinkComponent,
        data: {
          title: "Sialink",
        },
      },
    ],
  },
  {
    path: "settings",
    component: DefaultLayoutComponent,
    children: [
      {
        path: "users",
        loadChildren: "./views/users/users.module#UsersModule",
      },
      {
        path: "commands",
        loadChildren: "./views/commands/commands.module#CommandsModule",
      },
      {
        path: "customfields",
        loadChildren:
          "./views/custom-fields/custom-fields.module#CustomFieldsModule",
      },
      {
        path: "types",
        loadChildren: "./views/types/types.module#TypesModule",
      },
    ],
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
